import React, { createContext, useContext, useState, useCallback } from 'react';

const HeaderContext = createContext();

export const useHeader = () => {
  const context = useContext(HeaderContext);
  if (!context) {
    throw new Error('useHeader must be used within a HeaderProvider');
  }
  return context;
};

export const HeaderProvider = ({ children }) => {
  const [headerConfig, setHeaderConfig] = useState({
    pageTitle: null,
    pageSubtitle: null,
    pageActions: null,
    pageInfo: null,
    pageContext: null,
  });

  const setHeader = useCallback(({ pageTitle, pageSubtitle, pageActions, pageInfo, pageContext }) => {
    setHeaderConfig({
      pageTitle,
      pageSubtitle,
      pageActions,
      pageInfo,
      pageContext: pageContext ?? null,
    });
  }, []);

  const clearHeader = useCallback(() => {
    setHeaderConfig({
      pageTitle: null,
      pageSubtitle: null,
      pageActions: null,
      pageInfo: null,
      pageContext: null,
    });
  }, []);

  return (
    <HeaderContext.Provider value={{ headerConfig, setHeader, clearHeader }}>
      {children}
    </HeaderContext.Provider>
  );
};
